import main from '@/views/main.vue'

import index from '@/views/index.vue'
import orderlist from '@/views/order-list.vue'
import goodslist from '@/views/goods-list.vue'
import addgoods from '@/views/add-goods.vue'
import staffs from '@/views/staff-list.vue'

export default [{
  path: '/index',
  name: 'index',
  meta: {
    name: "首页",
    icon: "",
    auth: ""
  },
  component: index,
}, {
  path: '/orders',
  name: 'orders',
  meta: {
    name: "订单管理",
    icon: "",
    auth: ""
  },
  component: main,
  children: [{
    path: 'orderlist',
    name: 'orderlist',
    meta: {
      name: "订单列表",
      icon: "",
      auth: ""
    },
    component: orderlist,
  }]
}, {
  path: '/goods',
  name: 'goods',
  meta: {
    name: "商品管理",
    icon: "",
    auth: ""
  },
  component: main,
  children: [{
    path: 'orderlist',
    name: 'orderlist',
    meta: {
      name: "商品列表",
      icon: "",
      auth: ""
    },
    component: goodslist,
  }, {
    path: '/addgoods',
    name: 'home',
    meta: {
      name: "商品管理",
      icon: "",
      auth: ""
    },
    component: addgoods,
  }, ]
}, {
  path: '/goods',
  name: 'goods',
  meta: {
    name: "商品管理",
    icon: "",
    auth: ""
  },
  component: main,
  children: [{
    path: 'orderlist',
    name: 'orderlist',
    meta: {
      name: "商品列表",
      icon: "",
      auth: ""
    },
    component: goodslist,
  }, {
    path: '/addgoods',
    name: 'home',
    meta: {
      name: "商品管理",
      icon: "",
      auth: ""
    },
    component: addgoods,
  }, ]
}, {
  path: '/staffs',
  name: 'staffs',
  meta: {
    name: "商品管理",
    icon: "",
    auth: ""
  },
  component: staffs,
}]



// WEBPACK FOOTER //
// ./src/router/sliderPath.js